import script from "./BarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=bfab56b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfab56b8"]])

export default __exports__